module.exports = __webpack_public_path__ + "img/sort／web／Girl@2x.9a0acffb.png";